<template>
  <div class="hc-section">
    <div
      :id="props.section.slug"
      class="hc-section__title"
    >
      {{ props.section.title }}
    </div>
    <div
      v-if="props.section.rubrics"
      class="hc-section-rubrics"
    >
      <Rubric
        v-for="rubric in props.section.rubrics"
        :key="rubric.title"
        :rubric="rubric"
        :sectionSlug="props.section.slug"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { HelpCenterSection } from '@/shared/api/helpCenter';
  import Rubric from './Rubric.vue';

  interface IProps {
    section: HelpCenterSection;
  }
  const props = defineProps<IProps>();
</script>

<style scoped lang="scss">
  .hc-section {
    display: flex;
    gap: 24px;
    padding-top: 48px;

    @include adaptivity.tablet {
      flex-direction: column;
      gap: 12px;
    }
  }

  .hc-section__title {
    width: 100%;
    max-width: 182px;

    @include typography.base-500-400-semi;

    @include adaptivity.tablet {
      max-width: none;

      @include typography.base-600-500-extra;
    }
  }

  .hc-section-rubrics {
    display: flex;
    flex-direction: column;
    gap: 24px;

    @include adaptivity.tablet {
      gap: 32px;
    }
  }
</style>
